import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";

// State
export interface PlayerState {
  selectedChildUid: string | null;
}

const initialState: PlayerState = {
  selectedChildUid: null,
};

// Slice
const playerSlice = createSlice({
  name: "player",
  initialState,
  reducers: {
    setSelectedChildUid(state: PlayerState, action: PayloadAction<string | null>) {
      state.selectedChildUid = action.payload;
    },
  },
});

// Selectors
export const selectSelectedChildUid = (state: RootState) => state.player.selectedChildUid;

export const playerActions = { ...playerSlice.actions };

export default playerSlice.reducer;
